export default class ENTRY_STATUS {
  static CODE = {
    ORDERED: 'ORDERED',
    SHIPPED: 'SHIPPED',
    REGISTERED: 'REGISTERED',
    DOWNLOAD_AVAILABLE: 'DOWNLOAD_AVAILABLE',
    DOWNLOADED: 'DOWNLOADED',
  };

  static exists(code) {
    return Object.values(ENTRY_STATUS.CODE).includes(code);
  }

  static name(status) {
    switch (status) {
      case ENTRY_STATUS.CODE.ORDERED:
        return '発送準備中';
      case ENTRY_STATUS.CODE.SHIPPED:
        return '発送完了';
      case ENTRY_STATUS.CODE.REGISTERED:
        return 'ダウンロード準備中';
      case ENTRY_STATUS.CODE.DOWNLOAD_AVAILABLE:
        return '未ダウンロード';
      case ENTRY_STATUS.CODE.DOWNLOADED:
        return 'ダウンロード済';
      default:
        return '';
    }
  };

}